import { temporarilyNotSupport } from '../../utils'

// NFC
export const stopHCE = temporarilyNotSupport('stopHCE')
export const startHCE = temporarilyNotSupport('startHCE')
export const sendHCEMessage = temporarilyNotSupport('sendHCEMessage')
export const onHCEMessage = temporarilyNotSupport('onHCEMessage')
export const offHCEMessage = temporarilyNotSupport('offHCEMessage')
export const getNFCAdapter = temporarilyNotSupport('getNFCAdapter')
export const getHCEState = temporarilyNotSupport('getHCEState')
